import {getCookies} from '../../utils/getters/getCookies';

const NOTIFICATION_HIDE_CLASS = 'hidden';

const CLOSE_BUTTON_SELECTOR = 'button.close';

export const initNotification = () => {
	const notification = document.querySelector( 'div.notification' );
	const closeButton = notification?.querySelector( CLOSE_BUTTON_SELECTOR );
	const link = notification?.querySelector( 'a.text-wrapper' );

	if ( !notification || !closeButton || !link )
	{
		return;
	}

	const currentCookies = getCookies();

	const hideNotification = () => {
		const today = new Date();
		const expires = new Date();

		notification.classList.add( NOTIFICATION_HIDE_CLASS );
		closeButton.removeEventListener( 'click', hideNotification );
		
		expires.setTime( today.getTime() + 1000 * 60 * 60 * 24 * 14 );
		document.cookie = `notification_how_to_get_apartment=notification_how_to_get_apartment; expires=${expires.toGMTString()}; path=/`;
	};
	
	if ( currentCookies['notification_how_to_get_apartment'] )
	{
		notification.remove();
	}
	else if ( link.href && location.href.includes( link.href ) )
	{
		/* Удаляет информационный блок, если адрес текущей страницы совпадает с адресом в ссылке */
		notification.remove();
	}
	else
	{
		notification.classList.remove( NOTIFICATION_HIDE_CLASS );
		closeButton.addEventListener( 'click', hideNotification );
	}
};
